module.exports = __webpack_public_path__ + "static/media/iconPayment.e2cf2c64.svg";